import { createAsyncThunk } from '@reduxjs/toolkit';

import { MyInvestmentsService } from 'api';

import { DownloadInvestmentAgreementProps } from 'models/api';

export const getSaleProject = createAsyncThunk(
	'myInvestments/getSaleProject',
	async (params: DownloadInvestmentAgreementProps) => {
		return await MyInvestmentsService.getSaleProject(params);
	},
);
